var map = {
	"./dice-1.png": "063b",
	"./dice-2.png": "0abe",
	"./dice-3.png": "b981",
	"./dice-4.png": "c40e",
	"./dice-5.png": "2fd2",
	"./dice-6.png": "9060"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "303d";